<script>
    import * as integrationService from "./service.js";
    import BreadCrumNav from "../../components/breadcrum-nav.svelte";
    import V2List from './_components/v2-list.svelte';
    import { format } from 'svelte-i18n';

    let integrations = $state([]);

    let allPromises = $state(
        Promise.all([integrationService.search()])
            .then(([pIntegrations]) => {
                integrations = pIntegrations;
                integrations.forEach(integration => {
                    integration.label = $format(`page.user.roles.${integration.role}`);
                });
                return integrations;
            })
            .catch(e => {
                return [];
            })
    );

    const handleTableRefresh = (is_refresh = false) => {
        allPromises = Promise.all([integrationService.search()])
            .then(([pIntegrations]) => {
                integrations = pIntegrations;
                integrations.forEach(integration => {
                    integration.label = $format(`page.user.roles.${integration.role}`);
                });
                return integrations;
            })
            .catch(e => {
                return [];
            });
    }
</script>

<style>
</style>

<section class="content-header">
    <div class="container-fluid">
        <div class="row">
            <div class="col-6">
                <h1 class="mt-3 mb-3 page-title">
                    <i class="fas fa-sitemap fa-xs"></i>
                    {$format("layout.sidebar.integrations")}
                </h1>
            </div>
            <div class="col-6">
                <BreadCrumNav routes={[{ label: $format("layout.sidebar.integrations") }]} />
            </div>
       </div>
    </div>
</section>

<section class="content">
    <div class="container-fluid">
        {#await allPromises then data}
            <V2List
                data={data}
                onadd={handleTableRefresh}
                ondel={handleTableRefresh}
                onedit={handleTableRefresh}
                ontableRefresh={() => handleTableRefresh(true)}
            />
        {/await}
        {#await allPromises}
            <div class="overlay">
                <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
        {/await}
    </div>
</section>